import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App/App';
import { GlobalStyles, ThemeProvider, CssBaseline } from "@mui/material";
// import { globalStyles } from "./styles/globalStyles";
import { theme } from "./styles/theme";
import { ResponsiveScalerProvider } from "./lib/ResponsiveScaler/context";
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ThemeProvider theme={theme}>
    <ResponsiveScalerProvider>
      <CssBaseline />
      <App />
    </ResponsiveScalerProvider>
  </ThemeProvider>
);
